export default __webpack_public_path__ + "static/media/competition_bg.f707f638.jpg";